<svg
  [class]="fillColorClass"
  [style.width.px]="width"
  [style.height.px]="height"
  [style.color]="color"
  [attr.viewBox]="viewBox"
>
  <use [attr.href]="iconUrl"></use>
</svg>
